import * as React from 'react';
import { Icon, IconTypes } from '../Icon';
import { styles } from './styles';
import { buildReactStateHandler } from '@lib';

interface Props {
  placeholder?: string;
  value: string;
  disabled?: boolean;
  iconType: IconTypes;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFocus: (focused: boolean, label: string) => void;
  handleBlur: (focused: boolean, label: string) => void;
  error: boolean;
  errorText?: string;
  label: string;
  required?: boolean;
  dataInput: string;
  type: HTMLInputElement['type'];
  name?: string;
}

interface State {
  focused: boolean;
}
const stateHandler = buildReactStateHandler<State>();

export class Input extends React.Component<Props, State> {
  readonly state: State = {
    focused: false
  };

  handleOnFocus = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.currentTarget.dataset.input;
    this.setState(
      stateHandler(draft => {
        draft.focused = true;
      }),
      () => this.props.handleFocus(this.state.focused, target!)
    );
  };

  handleOnBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.currentTarget.dataset.input;
    this.setState(
      stateHandler(draft => {
        draft.focused = false;
      }),
      () => this.props.handleBlur(this.state.focused, target!)
    );
  };

  render() {
    const { focused } = this.state;
    const {
      onChange,
      placeholder = '',
      value,
      disabled = false,
      iconType,
      label,
      error,
      dataInput,
      handleFocus,
      handleBlur,
      errorText = 'Please fill out field correctly',
      required = false,
      ...props
    } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.inputContainer(error, focused)}>
          <div className={styles.iconWrapper}>
            <Icon type={iconType} />
          </div>
          <div className={styles.inputWrapper}>
            <label className={styles.visiblyHidden} htmlFor={label}>
              {required ? `${label} *` : label}
            </label>
            <input
              onChange={onChange}
              className={styles.input}
              placeholder={placeholder}
              id={label}
              onFocus={this.handleOnFocus}
              onBlur={this.handleOnBlur}
              value={value}
              data-input={dataInput}
              disabled={disabled}
              required={required}
              {...props}
            />
          </div>
        </div>
        {error && <span className={styles.errorText}>{errorText}</span>}
      </div>
    );
  }
}
